'use strict';

angular.module('mediacloudApp')
    .controller('InstalledZoomController', function ($rootScope, $scope, $location, $window, $state, $timeout, Auth, Principal, SchedulerService, Tenant) {
        $scope.setShowAlert = function(state){
            $scope.showAlert = state;
            if(state){
                $timeout(function(){
                    $scope.showAlert = false;
                }, 5000);
            }
        };

        $scope.setShowAlert(true);
    });
